import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["size", "unit", "count", "summary"];

  connect() {
    this.updateSummary();
  }

  updateSummary() {
    const size = this.sizeTarget.value;
    const unit = this.unitTarget.value;
    const count = this.countTarget.value;

    if (size && unit && count) {
      const totalQuantity = (size * count).toLocaleString("fr-FR");
      let summary = "";

      if (unit === "pièce") {
        if (count == 1) {
          summary = `Cette recette produit 1 portion de ${size} ${unit}${
            size > 1 ? "s" : ""
          }.`;
        } else {
          summary =
            `Cette recette produit ${count} portions de ${size} ${unit}${
              size > 1 ? "s" : ""
            } chacune, ` + `soit un total de ${totalQuantity} ${unit}s.`;
        }
      } else {
        if (count == 1) {
          summary = `Cette recette produit 1 portion de ${size}${unit}.`;
        } else {
          summary =
            `Cette recette produit ${count} portions de ${size}${unit} chacune, ` +
            `soit un total de ${totalQuantity}${unit}.`;
        }
      }

      this.summaryTarget.textContent = summary;
      this.summaryTarget.classList.remove("hidden");
    } else {
      this.summaryTarget.classList.add("hidden");
    }
  }
}
